import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NewsletterRequest, TopicoResponse } from 'app/shared/models/ei-models';
import { DefaultComponentsModule } from 'app/shared/modules/default-components.module';
import { ArquivoService, NewsletterService } from 'app/shared/services/edduca-imob';
import { FormBuilder, Validators } from '@angular/forms';
import { GlobalService } from 'app/shared/services/core';

@Component({
  selector: 'app-newsletter-register',
  imports: [DefaultComponentsModule],
  templateUrl: './newsletter-register.component.html',
  styleUrl: './newsletter-register.component.scss'
})
export class NewsletterRegisterComponent implements OnInit{

  topicos: TopicoResponse[] = [];
  imagemPreview: string | null = null;
  selectedFile: File | null = null;

  form = this.fb.group({
    titulo: ['', Validators.required],
    texto: ['', Validators.required],
    topicoId: [null, Validators.required],
    fonteImagem: ['', Validators.required],
    autor: ['', Validators.required],
  });

  constructor(
    private fb: FormBuilder,
    private _globalService: GlobalService,
    private newsletterService: NewsletterService,
    private arquivoService: ArquivoService,
    private dialogRef: MatDialogRef<NewsletterRegisterComponent>
  ) { }

  ngOnInit(): void {
    this.newsletterService.listarTopicos().subscribe(res => this.topicos = res);
  }

  onFileSelected(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;
    this.selectedFile = file;

    const reader = new FileReader();
    reader.onload = () => this.imagemPreview = reader.result as string;
    reader.readAsDataURL(file);
  }

  salvar(): void {
    if (this.form.invalid || !this.selectedFile) return;
    const usuarioId = this._globalService.getIdUserLogged();

    this.arquivoService.upload(this.selectedFile, usuarioId).subscribe(arquivo => {

      const request: NewsletterRequest = {
        ...this.form.value,
        usuarioCriacaoId: usuarioId,
        arquivoId: arquivo.id
      } as NewsletterRequest;

      this.newsletterService.criarNewsletter(request).subscribe(() => {
        this.dialogRef.close(true);
      });
    });
  }

  cancelar(): void {
    this.dialogRef.close();
  }
}
